import React from 'react';
import { User } from 'types/userInfo';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import personIcon from '../../icons/person-icon.svg';
import UserNameTooltip from '../ToolTips/UserNameTooltip';
import { useMapStore } from 'contexts/RootStore.context';
import { observer } from 'mobx-react';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { style } from 'typestyle';
import useMap from 'views/map/hooks/useMap';
import { MAX_ZOOM_FOR_DISPLAY_CLUSTERS } from 'stores/MapStore';
import { UserColor } from 'views/map/Styled';

export const UserMarkers = observer(({ users }: { users: User[] }) => {

  const {
    filterForm,
    mapZoom,
    // to force re-render on map move and show the tooltips
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    mapMoveVersion
  } = useMapStore();
  const { isMarkerVisible } = useMap(useMapStore());

  const customIcon = new L.Icon({
    iconUrl: personIcon,
    iconSize: new L.Point(20, 20),
    iconAnchor: [10, 10], // half of icon size.
    className: 'leaflet-custom-icon',
  });

  const markers = users.map((user: User) => {
    const markerLong = user.location.coordinates.longitude;
    const markerLat = user.location.coordinates.latitude;

    return (
      <Marker title={`${user.name}`} icon={customIcon} position={[markerLat, markerLong]}>
        {filterForm.$.displayUserName.value && isMarkerVisible(user) && <UserNameTooltip user={user} />}
      </Marker>
    )
  })

  return (
    <>
      {mapZoom < MAX_ZOOM_FOR_DISPLAY_CLUSTERS
        ? < MarkerClusterGroup
          iconCreateFunction={(cluster: any) => {
            const count = cluster.getChildCount();
            return new L.DivIcon({
              html: `<div>${count}</div>`,
              className: ClusterStyle,
              iconSize: L.point(40, 40, true),
            });
          }}
          chunkedLoading
          maxClusterRadius={80}
          spiderfyOnMaxZoom
          showCoverageOnHover={true}
        >
          {markers}
        </MarkerClusterGroup >
        : markers
      }
    </>
  );
})

const ClusterStyle = style({
  background: UserColor,
  borderRadius: '50%',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold'
})